// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import { useEffect, useState } from "react";
import { Grid, Typography, Dialog } from "@mui/material";
import NextEvents from "../components/NextEvents";
import ActivityItem from "../components/ActivityItem";
// import { activities } from "../data/activityData";
import { PlayCircleFilled } from "@mui/icons-material";

function Home(props) {
  // const [activities, setActivities] = useState([]);
  const [currentActivities, setCurrentActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  let handleShowDialog = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const currentActivityArray = [];
    fetch(process.env.PUBLIC_URL + "/data/activityData.json", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      cache: "no-cache",
    })
      .then(function (originalResponse) {
        return originalResponse.json();
      })
      .then(function (jsonResponse) {
        jsonResponse.map((element) => {
          let dateArray = element.date.match(
            /^(\d{4})\.(\d{2})\.(\d{2})\s*(\d{2})*:*(\d{2})*$/
          );
          element.date = new Date(
            dateArray[1],
            dateArray[2] - 1,
            dateArray[3],
            dateArray[4],
            dateArray[5]
          );
          if (element.currentActivity === "true")
            currentActivityArray.push(element);
          return element;
        });
        // setActivities(jsonRespWithDate);
        setCurrentActivities(currentActivityArray);
        setLoadingActivities(false);
      })
      .catch((err) => console.log(err));
  }, []);

  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        [theme.breakpoints.down("md")]: {
          marginTop: 2,
        },
        [theme.breakpoints.up("md")]: {
          marginTop: 10,
        },
      })}
      justifyContent="center">
      <Grid
        item
        xs={12}
        style={{ position: "relative" }}>
        <div
          style={{
            position: "relative",
          }}>
          <img
            alt=""
            src={
              process.env.PUBLIC_URL +
              "/images/startpage_emotion.jpg"
            }
            width="100%"
            hight="auto"></img>
          {/* set the following block in comment if an advertisment block is to be displayed */
            <Typography
              sx={(theme) => ({
                position: "absolute",
                width: "25%",
                borderRadius: "5px",
                bottom: "0",
                right: "7%",
              })}
              onClick={handleShowDialog}>
              <img
                alt=""
                src={process.env.PUBLIC_URL + "/images/uebungsvideo.png"}
                width="100%"
                hight="auto"></img>
              <PlayCircleFilled
                sx={(theme) => ({
                  position: "absolute",
                  right: "40%",
                  color: theme.palette.primary.main,
                  [theme.breakpoints.down("sm")]: {
                    fontSize: 20,
                    bottom: "10%",
                  },
                  [theme.breakpoints.up("sm")]: {
                    fontSize: 30,
                    bottom: "15%",
                  },
                  [theme.breakpoints.up("md")]: {
                    fontSize: 40,
                    bottom: "15%",
                  },
                })}
              />
              {isOpen && (
                <Dialog
                  open={isOpen}
                  onClose={handleShowDialog}>
                  <video
                    width="100%"
                    autoPlay={true}
                    controls
                    onClick={handleShowDialog}>
                    <source
                      src={
                        process.env.PUBLIC_URL + "/videos/20241019_ua_web.mp4"
                      }
                      type="video/mp4"
                    />
                  </video>
                </Dialog>
              )}
            </Typography>
          /* end comment block */}
        </div>
        {/* start advertisment block */}
        {/* <div
          style={{
            width: "36%",
            height: "76%",
            position: "absolute",
            margin: "0",
            padding: "0",
            right: "5%",
            bottom: "7%",
            cursor: "pointer",
            //opacity: "0.8",
            overflow: "hidden",
            background: "#C33764",
            background:
              "-webkit-linear-gradient(rgba(207, 207, 207, 0.5), rgba(102, 54, 70, 0.5)), url(" +
              process.env.PUBLIC_URL +
              "/images/2024/20240428_kirtagflyer_1.jpg)",
            background:
              "linear-gradient(rgba(207, 207, 207, 0.5), rgba(102, 54, 70, 0.5)), url(" +
              process.env.PUBLIC_URL +
              "/images/2024/20240428_kirtagflyer_1.jpg)",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            borderRadius: "5px",
          }}
          onClick={handleShowDialog}></div>
        {isOpen && (
          <Dialog
            open={isOpen}
            onClose={handleShowDialog}>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/2024/20240428_kirtagflyer_1.jpg"
              }
              alt=""
              width="100%"
              hight="auto"
              onClick={handleShowDialog}
            />
          </Dialog>
        )} */}
        {/* end advertisement block */}
        <Typography
          variant="body1"
          sx={(theme) => ({
            textAlign: "center",
          })}>
          Unsere Freizeit für Eure Sicherheit! Für&nbsp;Notruf&nbsp;
          <strong>122</strong>&nbsp;wählen!
        </Typography>
      </Grid>
      <Grid
        item
        marginTop={2}
        xs={12}>
        <Typography
          variant="h5"
          component="h2">
          Kommende Termine
        </Typography>
      </Grid>
      <Grid
        item
        xs={12}>
        {/* <NextEvents date={new Date(2023, 6, 23)} /> */}
        <NextEvents />
      </Grid>
      <Grid
        item
        marginTop={2}
        xs={12}>
        <Typography
          variant="h5"
          component="h2">
          Aktuelles
        </Typography>
      </Grid>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        item>
        {loadingActivities === true && (
          <Grid
            item
            xs={12}>
            <Typography variant="body2">wird gerade geladen...</Typography>
          </Grid>
        )}
        {currentActivities.map((activity, i) => {
          return (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={i}>
              <ActivityItem activityData={activity} />
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}

export default Home;
